import React from 'react'
import Pencil from 'ui/icons/Pencil'
import SquareButton from 'ui/buttons/SquareButton'

function DefaultEditButton (props) {
  return (
    <SquareButton color='btn-lightgray' className='p-2' {...props}>
      <Pencil />
    </SquareButton>
  )
}

export default DefaultEditButton
